// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"Tags_tagsList__1EwxY","tagItem":"Tags_tagItem__vS_2V","tag":"Tags_tag__2r0TC","title":"Tags_title__3w9vX"};